<template>
  <div>
    <p>Real Estate Investment Experience</p>
    <vue-form-generator ref="formRealEstate" :schema="schema" :model="model" />
    <p>
      Real Estate Management Experience (Only complete if you wish to finance
      rental properties)
    </p>
    <vue-form-generator
      ref="formRealEstateManagement"
      :schema="managementSchema"
      :model="model"
    />
    <wizard-verified-submit-button
      text="Update Real Estate Data"
      @submit="submit"
    />
    <hr />
    <p>Schedule of Real Estate</p>


    <b-container>
      <b-row>
        <b-col>
          <b-button
            class="btn btn-anchor raised form-submit-btn btn-secondary"
            @click="openUploadModal"
          >
            Upload Experience
          </b-button>
        </b-col>
        <b-col><verified-submit-button
          target="new-operation-btn"
          text="+ Add Experience"
          @submit="showExperienceModal"
        /></b-col>
      </b-row>
    </b-container>

    <b-modal
      id="upload-files"
      header-class="anchor-modal"
      :title="`Upload files - Borrower Stated Expirience`"
      v-model="showUploadModal"
      hide-footer
      :no-close-on-backdrop="modalNoCloseOnBackdrop"
      :no-close-on-esc="modalNoCloseOnEsc"
      :hide-header-close="modalHideHeaderClose"
    >
      <upload
        :url-upload="`users/${user.id}/docs`"
        @success="onSuccesUpload"
        @upload="uploadStart"
        @cancel="cancelUploadByUser"
        :show-input="true"
        :auto-send="false"
        :multiple="false"
        :params="uploadParams"
      />
    </b-modal>

    <real-estate-operation-modal
      ref="newRealEstateOperation"
      @success="realEstateOperationSaved"
    />
    <b-row
      class="mb-3 mt-3"
      v-for="operation in realEstateOperation"
      :key="operation.id"
    >
      <b-col>
        <b-card>
          <address-display :address="operation.propertyAddress" />
          <hr />
          <b-row class="mb-3">
            <font-awesome-icon
              size="sm"
              @click="confirmRemove(operation)"
              id="btn-remove-operation"
              class="content__close-button mr-2 mt-2"
              icon="times"
            />
            <b-col>
              <div>
                <strong>% Ownership: </strong>
                {{ operation.ownershipPercentage }} %
              </div>
              <div>
                <strong>Purchase Date: </strong> {{ operation.purchaseDate }}
              </div>
              <div><strong>Sale Date: </strong> {{ operation.saleDate }}</div>
            </b-col>
            <b-col>
              <div>
                <strong>PropertyType: </strong>
                {{ propertyTypes[operation.propertyType] }}
              </div>
              <div>
                <strong>Purchase Price: </strong>
                {{ operation.purchasePrice || "-" | currency }}
              </div>
              <div>
                <strong>Annual salary: </strong>
                {{ operation.salePrice || "-" | currency }}
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueFormGenerator from 'vue-form-generator';
import WizardVerifiedSubmitButton from '@/components/utils/buttons/form/WizardVerifiedSubmitButton';
import AddAssetButton from '@/components/utils/buttons/misc/AddAssetButton';
import AddressDisplay from '@/components/utils/address/AddressDisplay';
import Upload from '@/components/utils/upload/Upload';
import AdditionalFilesForm from '@/components/my_deals/actions/AdditionalFilesForm';

import helper from '@/libs/helper';
import {
  DEFINE_PROFILE_REAL_ESTATE_EXPERIENCE,
  DEFINE_PROFILE_REAL_ESTATE_OPERATION,
} from '@/vuex/modules/profile/types/actions';
import { APPLICATION_TAB } from '@/components/profile/sections/tabs/tabNumbers';
import PROPERTY_TYPES from '@/components/profile/sections/tabs/real_estate/resources/propertyTypes';
import REAL_STATE_SCHEMA from '@/components/profile/sections/tabs/real_estate/schemas/schema';
import REAL_STATE_MANAGEMENT_SCHEMA from '@/components/profile/sections/tabs/real_estate/schemas/realStateManagementSchema';
import REAL_ESTATE_MODEL from '@/components/profile/sections/tabs/real_estate/resources/realEstate';
import VerifiedSubmitButton from '@/components/utils/buttons/form/VerifiedSubmitButton';
import RealEstateOperationModal from '@/components/profile/sections/tabs/real_estate/RealEstateOperationModal';

export default {
  components: {
    'vue-form-generator': VueFormGenerator.component,
    AddAssetButton,
    AddressDisplay,
    RealEstateOperationModal,
    VerifiedSubmitButton,
    WizardVerifiedSubmitButton,
    AdditionalFilesForm,
    Upload,
  },
  data() {
    return {
      model: this.getModel(),
      schema: REAL_STATE_SCHEMA.schema,
      formExperienceOptions: REAL_STATE_SCHEMA.options,
      managementSchema: REAL_STATE_MANAGEMENT_SCHEMA.schema,
      APPLICATION_TAB,
      propertyTypes: PROPERTY_TYPES,
      modalRecord: {},
      uploadParams: {},
      showUploadModal: false,
      isMounted: false,
      targetVerificationUserAlert: '',
      modalNoCloseOnBackdrop: false,
      modalNoCloseOnEsc: false,
      modalHideHeaderClose: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    realEstateOperation() {
      return this.$store.getters.profile.realEstateOperation;
    },
  },
  methods: {
    getModel() {
      return helper.copy(REAL_ESTATE_MODEL);
    },
    isValid() {
      return this.$refs.formRealEstate.validate();
    },
    clearValidationErrors() {
      this.$refs.formRealEstate.clearValidationErrors();
    },
    submit(moveTab) {
      if (this.isValid()) {
        if (this.model.rentalManagementCourseComplete !== true) {
          this.model.rentalManagementCourseCompleteDate = null;
          this.model.rentalManagementCourseName = null;
        }
        this.$reqs
          .post(
            `/users/${this.$store.getters.user.id}/profile/real_estate_experience`,
            this.model,
          )
          .then((response) => {
            this.$store.dispatch(DEFINE_PROFILE_REAL_ESTATE_EXPERIENCE, {
              realEstateExperience: response.data.realEstateExperience,
            });
            this.$emit('tab-info-updated', 'Real Estate');
            if (moveTab) {
              this.$emit('move-to-next-tab', APPLICATION_TAB);
            }
          })
          .catch(() => {});
      }
    },
    confirmRemove(operation) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this action!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
      }).then((result) => {
        if (result.value) {
          this.removeOperation(operation);
        }
      });
    },
    removeOperation(operation) {
      this.$reqs
        .delete(
          `/users/${this.user.id}/profile/real_estate_operation/${operation.id}`,
        )
        .then((response) => {
          this.$store.dispatch(DEFINE_PROFILE_REAL_ESTATE_OPERATION, {
            realEstateOperation: response.data.realEstateOperation,
          });
          this.$swal(
            'Deleted!',
            'Your experience has been deleted.',
            'success',
          );
        })
        .catch(() => {});
    },
    showExperienceModal() {
      this.$refs.newRealEstateOperation.show();
    },
    realEstateOperationSaved() {
      this.$emit('tab-info-updated', 'Experience');
    },
    openUploadModal() {
      this.targetVerificationUserAlert = 'upload-borrower-stated-experience';
      this.uploadParams = { type: 'Borrower Stated Experience' };
      this.modalNoCloseOnBackdrop = false;
      this.modalNoCloseOnEsc = false;
      this.modalHideHeaderClose = false;
      this.showUploadModal = true;
    },
    onSuccesUpload() {
      this.showUploadModal = false;
      this.$swal.fire({
        type: 'success',
        title: 'Uploaded successfully',
      });
    },
    cancelUploadByUser() {
      this.showUploadModal = false;
    },
    uploadStart() {
      this.modalNoCloseOnBackdrop = true;
      this.modalNoCloseOnEsc = true;
      this.modalHideHeaderClose = true;
    },
  },
  created() {
    const profile = this.$store.getters.profile;
    if (profile && profile.realEstateExperience) {
      this.model = helper.copy(profile.realEstateExperience);
    }
  },
};
</script>
<style scoped>
.content__close-button {
  cursor: pointer;
  color: #dc3545;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/sections/tabs/real_estate/RealEstateContent.vue